import { useQuery } from "react-query";
import { fetchVariant, fetchVariants } from "../queries/variants.queries";
import { PaginatedFilter } from "../types/axios.types";

export const useVariant = (id: number | string | undefined) => {
	return useQuery(["variant", id], () => {
		try {
			return fetchVariant(id);
		} catch (err) {
			return null;
		}
	});
};

export const useVariants = ({
	prefilter = {},
}: {
	prefilter: PaginatedFilter;
}) => {
	return (
		page?: number,
		size?: number,
		search?: string,
		filters?: PaginatedFilter,
		sortBy?: string[],
	) => {
		const computedFilters = { ...prefilter, ...filters };
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const query = useQuery(
			["variants", page, size, search, computedFilters, sortBy],
			() => {
				try {
					return fetchVariants(page, size, search, computedFilters, sortBy);
				} catch (err) {
					return null;
				}
			},
			{ keepPreviousData: true },
		);
		return query?.data;
	};
};
